export * from './DrawingArea';
export { default } from './DrawingArea';
